import type { IUser, Role } from './User';

export const workspaceColorsMap = {
  'bg-ds-primary-200': '#29A9FF',
  'bg-ds-primary-300': '#0078EF',
  'bg-ds-accent2-400': '#38D695',
  'bg-ds-accent1-300': '#FF73A9',
  'bg-ds-danger-200': '#F37A61',
  'bg-ds-secondary-500': '#B75C19',
  'bg-ds-secondary-400': '#FF9D33',
};

export type WorkspaceColor = keyof typeof workspaceColorsMap;
export type WorkspaceAccess = 'joined' | 'not_joined';
export type WorkspaceNarrowType = 'private' | 'public';
export type WorkspaceType = WorkspaceNarrowType | 'default' | 'playground';

export type WorkspaceMember = {
  id: string;
  workspaceId: number;
  lastAccessTime: string;
  createTime: string;
  updateTime: string;
  archiveTime?: string;
  isDeleted: boolean;
  isArchived?: boolean;
  user: IUser;
  role: Exclude<Role, 'visitor'>;
};

export type WorkspaceSettings = {
  workspaceName: string;
  workspaceType: WorkspaceType;
  color: WorkspaceColor;
};

export type Workspace = {
  id: string;
  workspaceName: string;
  workspaceType: WorkspaceType;
  color: WorkspaceColor;
  createTime: string;
  updateTime: string;
  archiveTime?: string;
  isDeleted: boolean;
  isArchived?: boolean;
  totalMembers?: number;
  creator: Omit<IUser, 'rolesToPermissions'>;
  tags?: Array<string>;
  totalSharedFolders?: number;
  isMember?: boolean;
  access?: WorkspaceAccess;
};
